import type { IIndicatorTheme } from '@visactor/vchart';

export const indicator: IIndicatorTheme = {
  title: {
    visible: true,
    style: {
      fill: '#12141A',
      fontWeight: 500,
      fontSize: 16
    }
  },
  content: {
    visible: true,
    style: {
      fill: '#85878A',
      fontWeight: 400,
      fontSize: 12
    }
  }
};
